<template>
  <div class="wish-list">
    <span class="iconify svg--wishlist-inactive-product">
      <span class="path1" />
      <span class="path2" />
    </span>
    <!-- <span class="iconify svg--wishlist-active-product">
      <span class="path1" />
      <span class="path2" />
    </span>
    <span class="iconify svg--heart" />
     -->
  </div>
</template>

<script lang="ts">

export default defineComponent({
  name: 'ProductCardWishlist',
});

</script>

<style lang="scss" scoped>
.wish-list {
  span {
    font-size: 30px;
  }
}
</style>
